import { render, staticRenderFns } from "./Bouquets.vue?vue&type=template&id=12ba07ca&scoped=true"
import script from "./Bouquets.vue?vue&type=script&lang=js"
export * from "./Bouquets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba07ca",
  null
  
)

export default component.exports